import axiosInstance from "../../axios/axiosInstance";
import {
  ADD_PRODUCTS_SUBCATEGORY,
  BULK_UPLOAD,
  BULK_UPLOAD_IMAGE,
  BULK_UPLOAD_PRODUCT,
  CREATE_AI_PRODUCT,
  CREATE_PRODUCTS,
  DELETE_PRODUCT,
  DELETE_SUB_CATEGORY_PRODUCT,
  DOWNLOAD_PRODUCTS_EXCEL,
  INVENTORY_LISTING_PAGINATE,
  PRODUCT_IMAGE_DELETE,
  PRODUCTS_LISTING,
  PRODUCTS_LOW_STOCK_LISTING,
  PRODUCTS_OUT_STOCK_LISTING,
  PRODUCTS_SINGLE_LISTING,
  PRODUCTS_SUB_CATEGORY_LISTING,
  PRODUCTS_VARIANTS,
  STATUS_UPDATE_PRODUCT,
  UPDATE_PRODUCTS,
} from "../../constants";

export const createAiProduct = (formData, onUploadProgress) =>
  axiosInstance.post(CREATE_AI_PRODUCT, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 90000,
    onUploadProgress,
  });

export const createProducts = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_PRODUCTS, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const updateProducts = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(UPDATE_PRODUCTS, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const getProductsListing = (props) => (onResponse) => {
  try {
    let BASE_URL = PRODUCTS_LISTING;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getInventoryListingPaginate = (props) => (onResponse) => {
  try {
    let BASE_URL = INVENTORY_LISTING_PAGINATE;

    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getProductsSubcategoryListing = (id) => (onResponse) => {
  try {
    // let BASE_URL = PRODUCTS_SUB_CATEGORY_LISTING + id
    axiosInstance
      .get(PRODUCTS_SUB_CATEGORY_LISTING + id)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const addProductSubCategory = (props) => (onResponse) => {
  try {
    let BASE_URL = ADD_PRODUCTS_SUBCATEGORY;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getProductsOutStockListing = (props) => (onResponse) => {
  try {
    let BASE_URL = PRODUCTS_OUT_STOCK_LISTING;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getProductsLowStockListing = (props) => (onResponse) => {
  try {
    let BASE_URL = PRODUCTS_LOW_STOCK_LISTING;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getProductsVariants = (props) => (onResponse) => {
  try {
    let BASE_URL = PRODUCTS_VARIANTS;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err);
      });
  } catch (error) { }
};

export const getProductsDetails = (id) => (onResponse) => {
  try {
    axiosInstance
      .get(PRODUCTS_SINGLE_LISTING + id)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const deleteProduct = (id) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_PRODUCT, { data: { id: id } })
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const deleteSubCategoryProduct = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(DELETE_SUB_CATEGORY_PRODUCT, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const statusProductUpdate = (id) => (onResponse) => {
  try {
    axiosInstance
      .post(STATUS_UPDATE_PRODUCT, { productId: id })
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const uploadBulkProducts = (props) => (onResponse) => {
  try {
    let BASE_URL = BULK_UPLOAD_PRODUCT;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};

export const uploadBulkImage = (props) => (onResponse) => {
  try {
    let BASE_URL = BULK_UPLOAD_IMAGE;
    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) { }
};


export const deleteProductImage = (id) => (onResponse) => {
  try {
    axiosInstance.delete(PRODUCT_IMAGE_DELETE + '/' + id)
      .then((response) => {
        onResponse(response.data); // Pass only the data object
      })
      .catch((err) => {
        onResponse(err.response?.data); // Pass error data if available
      });
  } catch (error) { }
};

export const downloadProductsExcelSheet = (props) => {
  try {
    return axiosInstance.post(DOWNLOAD_PRODUCTS_EXCEL, props, {
      responseType: "blob", // important for file download
    });
  } catch (error) {
    console.error("Download Excel Error:", error);
  }
};